var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Menu","button-type":"danger","button-text":"Delete","show":_vm.shouldShow},on:{"update:show":function($event){_vm.shouldShow=$event},"confirm":_vm.deleteMenu}},[_c('p',[_vm._v(" Are you sure you want to delete this menu? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }